import { getEnvVariable } from "../../../../modules/environmentalList"

const ProjectMessagesTableEdit = {
    "type": "popup",
    "key": "ProjectMessagesTableEdit",
    "name": "ProjectMessagesTableEdit",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'editOpen'
    },
    sharedValues: ['open'],
    container: {
        values: { editProjectInfo: null, editInfo: null, edit: false, back: false, allgriddata: null, navigation: null, subnavigation: null, fullscreen: false },
        mapValues: {
            header: [
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'edit', name: 'edit' },
            ],
            EditProjectMessagesTable: [

                { key: 'editInfo', name: 'editInfo' },
                { key: 'allgriddata', name: 'allgriddata' },
                { key: 'editProjectInfo', name: 'editProjectInfo' },
                { key: 'save', name: 'save' },
                { key: 'edit', name: 'edit' },
                { key: 'back', name: 'back' },
                { key: 'navigation', name: 'navigation' },
                { key: 'subnavigation', name: 'subnavigation' },]
        },
        //  sharedValues: ['save', 'edit'],
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: '',
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12 px-1',
                    sub: {
                        type: 'div',
                        className: 'col-12 px-1',
                    }
                }],

            },


            {
                order: 1,
                type: 'div',
                className: 'row m-1 application-border',
                components: [{
                    name: 'EditProjectMessagesTable',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Property Messages',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "Project Messages", "appendval": "Name", "materialicon": "message", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },
                    {
                        type: 'icon',
                        icon: 'previtem',
                        name: 'previtem',
                        hideon: 'previtem',
                        hidevalue: false,
                        title: 'Previous Item'
                    },
                    {
                        type: 'icon',
                        icon: 'nextitem',
                        name: 'nextitem',
                        hideon: 'nextitem',
                        hidevalue: false,
                        title: 'Next Item'
                    },
                    {
                        type: 'icon',
                        icon: 'edit',
                        name: 'edit',
                        hideon: 'edit',
                        hidevalue: true,
                        title: 'Edit'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'save',
                        hideon: 'edit',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hideon: 'exitfullscreen',
                        hidevalue: false,
                        title: 'FullScreen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit FullScreen'
                    }
                ],


            },
            EditProjectMessagesTable: {
                "type": "form",
                "key": "EditProjectMessagesTable",
                "name": "EditProjectMessagesTable",
                noParams : true,
                aliases: {
                    'editInfo': 'editInfo',
                    'allgriddata': 'allgriddata',
                    'navigation': 'navigation',  //
                    'subnavigation': 'subnavigation'
                },
                sharedValues: ['editInfo', 'allgriddata', 'editProjectInfo', 'back', 'navigation', 'edit', 'save', 'subnavigation'],
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Key',
                                type: 'div',
                                className: 'col-10',
                                sub: {
                                    type: 'div',
                                    className: 'col-10',
                                }
                            }],

                        },
                        {
                            order: 1,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Type',
                                type: 'div',
                                className: 'col-10',
                                sub: {
                                    type: 'div',
                                    className: 'col-10',
                                }
                            },

                            ]
                        },

                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Message',
                                type: 'div',
                                className: 'col-10',
                                sub: {
                                    type: 'div',
                                    className: 'col-10',
                                }
                            },

                            ]
                        },

                        // {
                        //     order: 3,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [
                        //         {
                        //             name: 'Minlen',
                        //             type: 'div',
                        //             className: 'col-md-5 col-lg-4',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-md-5 col-lg-4',
                        //             }
                        //         },
                        //         {
                        //             name: 'Maxlen',
                        //             type: 'div',
                        //             className: 'col-md-5 col-lg-4',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-md-5 col-lg-4',
                        //             }
                        //         },
                        //     ]
                        // },
                        // {
                        //     order: 4,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [{
                        //         name: 'Mask',
                        //         type: 'div',
                        //         className: 'col-md-10 col-lg-8',
                        //         sub: {
                        //             type: 'div',
                        //             className: 'col-md-10 col-lg-8'
                        //         }
                        //     },
                        //     ]
                        // },
                        // {
                        //     order: 5,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [{
                        //         name: 'Regex',
                        //         type: 'div',
                        //         className: 'col-md-10 col-lg-8',
                        //         sub: {
                        //             type: 'div',
                        //             className: 'col-md-10 col-lg-8'
                        //         }
                        //     },
                        //     ]
                        // },
                        {
                            order: 7,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Status',
                                type: 'div',
                                className: 'col-10',
                                sub: {
                                    type: 'div',
                                    className: 'col-10',
                                }
                            },
                            ]
                        },
                        {
                            order: 8,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'CreatedOn',
                                type: 'div',
                                className: 'col-5',
                                sub: {
                                    type: 'div',
                                    className: 'col-5',
                                }
                            },
                            {
                                name: 'CreatedByName',
                                type: 'div',
                                className: 'col-5',
                                sub: {
                                    type: 'div',
                                    className: 'col-5',
                                }
                            },
                            ]
                        },
                        {
                            order: 9,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'UpdatedOn',
                                    type: 'div',
                                    className: 'col-5',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5',
                                    }
                                },
                                {
                                    name: 'UpdatedByName',
                                    type: 'div',
                                    className: 'col-5',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5',
                                    }
                                },]
                        },
                    ],
                },
                values: {
                    //    ColumnName: '',
                    Message: '',
                    Type: '',
                    // Minlen: '',
                    // Maxlen: '',
                    TableName: '',
                    // Mask: '',
                    // Regex: '',
                    UpdatedByName: '',
                    CreatedByName: '',
                    UpdatedOn: '',
                    CreatedOn: '',
                    UpdatedBy: '',
                    CreatedBy: '',
                    Id: '',
                    Order: 1,
                    Key: '',
                    Status: 'I',
                    editInfo: null,
                    allgriddata: null,
                    editProjectInfo: null,
                    navigation: null,
                    subnavigation: null
                },
                "components": {
                    Key: {
                        "type": "label",
                        "key": "Key",
                        "label": "Key",
                        "name": "Key",
                        changefieldto: "label",
                    },
                    Type: {
                        "type": "label",
                        "key": "Type",
                        "label": "Message Type",
                        "name": "Type",
                        changefieldto: "dropdown",
                        extraProps: {
                            transformProps: {
                                label: 'Name',
                                value: 'Value'
                            },
                        }
                    },
                    Key: {
                        "type": "label",
                        "key": "Key",
                        "label": "Column Name",
                        "name": "Key",
                        changefieldto: "label",
                        subname: 'TableName',
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        }
                    },
                    Message: {
                        "type": "label",
                        "key": "Message",
                        "label": "Message",
                        "name": "Message",
                        changefieldto: "textfield",
                    },

                    // Minlen: {
                    //     "type": "label",
                    //     "key": "Minlen",
                    //     "label": "Min",
                    //     "name": "Minlen",
                    //     "xtype": "number",
                    //     changefieldto: "textfield",
                    // },
                    // Maxlen: {
                    //     "type": "label",
                    //     "key": "Maxlen",
                    //     "label": "Max",
                    //     "name": "Maxlen",
                    //     "xtype": "number",
                    //     changefieldto: "textfield",
                    // },
                    // Mask: {
                    //     "type": "label",
                    //     "key": "Mask",
                    //     "label": "Mask",
                    //     "name": "Mask",
                    //     changefieldto: "textfield",
                    // },
                    // Regex: {
                    //     "type": "label",
                    //     "key": "Regex",
                    //     "label": "Regex",
                    //     "name": "Regex",
                    //     changefieldto: "textfield",
                    // },
                    Status: {
                        "type": "label",
                        "key": "Status",
                        "label": "Status",
                        "name": "Status",
                        changefieldto: "toggle",
                        extraProps: {
                            "transformProps": {
                                "A": true,
                                "I": false,
                                "true": "A",
                                "false": "I"
                            }
                        }

                    },
                    CreatedOn: {
                        "type": "label",
                        "key": "CreatedOn",
                        "label": "Created On",
                        name: "CreatedOn",
                        changefieldto: "label",
                    },
                    CreatedByName: {
                        "type": "label",
                        "key": "CreatedByName",
                        "label": "Created By",
                        name: "CreatedByName",
                        changefieldto: "label",
                    },
                    UpdatedOn: {
                        "type": "label",
                        "key": "UpdatedOn",
                        "label": "Updated On",
                        name: "UpdatedOn",
                        changefieldto: "label",
                    },
                    UpdatedByName: {
                        "type": "label",
                        "key": "UpdatedByName",
                        "label": "Updated By",
                        name: "UpdatedByName",
                        changefieldto: "label",
                    },
                },
                mapActionsToEffects: {
                    'onLoad': {
                        'init': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'load',
                                            name: 'Key',
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/DomainsMapper/GridByParams/modulemaster.ProjectMessages?autoComplete=false`,
                                                    alternateUrl: getEnvVariable('MasterAdmin') + `/api/DomainsMapper/GridByParams/master.ProjectMessages?autoComplete=false`,
                                                    condition: [
                                                        { value: 'Master', name: 'editInfo.Path' }
                                                    ], type: 'post',
                                                    alert: true,
                                                    saveAs: {
                                                        key: 'items'
                                                    },
                                                    "matchProps": [
                                                        {
                                                            name: "editInfo.Value",
                                                            key: "name",
                                                        }
                                                    ],
                                                    sublist: 'TableName',
                                                    body: {
                                                        "TABLENAME": "editInfo.Value"
                                                    },
                                                    replaceBody: true,
                                                    word: "TABLENAME"
                                                }
                                            ]
                                        },
                                        {
                                            type: 'getValue',
                                            name: 'TableName',
                                            getdatafrom: 'editInfo',
                                            getValue: 'Value'
                                        },
                                        // {
                                        //     type: 'grid',
                                        //     name: 'Key',
                                        //     "read": [
                                        //         {
                                        //             url: getEnvVariable('Admin') + `/api/DomainsMapper/GridByParams/modulemaster.ProjectMessages?autoComplete=false`,
                                        //             alternateUrl: getEnvVariable('MasterAdmin') + `/api/DomainsMapper/GridByParams/master.ProjectMessages?autoComplete=false`,
                                        //             condition: [
                                        //                 { value: 'Master', name: 'editInfo.Path' }
                                        //             ],
                                        //             type: 'post',
                                        //             alert: true,
                                        //             saveAs: {
                                        //                 key: 'items'
                                        //             },
                                        //             "matchProps": [
                                        //                 {
                                        //                     name: "editInfo.Value",
                                        //                     key: "name",
                                        //                 }
                                        //             ],
                                        //             sublist: 'TableName',
                                        //             body: {
                                        //                 "TABLENAME": "editInfo.Value"
                                        //             },
                                        //             replaceBody: true,
                                        //             word: "TABLENAME"
                                        //         }
                                        //     ]
                                        // },
                                        {
                                            type: 'load',
                                            name: 'Type',
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/Domains/values?domainkey=PROJECT_MESSAGE_TYPE`,
                                                    type: 'get',
                                                    saveAs: {
                                                        key: 'items'
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            type: 'validations',
                                            "read": [
                                                {
                                                    "url": getEnvVariable('MasterAdmin') + `/api/ProjectMessages/RulesByName?name=modulemaster.projectmessages`,
                                                    type: 'get'
                                                }
                                            ],
                                            transformProps: {
                                                removesubfieldname: 'MODULEMASTER.PROJECTMESSAGES_'
                                            }
                                        },
                                    ]
                                }
                            },
                                // {
                                //     canOverwrite: true,
                                //     check: [{
                                //         condition: "AND",
                                //         rules: [{
                                //             name: "Type", type: "=", value: 'I', rules: []
                                //         },
                                //         ]
                                //     }],
                                //     uncheck: true,
                                //     run: {
                                //         valid: [
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Minlen',
                                //                 isVisible: false
                                //             },
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Maxlen',
                                //                 isVisible: false
                                //             },
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Mask',
                                //                 isVisible: false
                                //             },
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Regex',
                                //                 isVisible: false
                                //             },
                                //         ],
                                //         inValid: [
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Minlen',
                                //                 isVisible: true
                                //             },
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Maxlen',
                                //                 isVisible: true
                                //             },
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Mask',
                                //                 isVisible: true
                                //             },
                                //             {
                                //                 type: 'prop',
                                //                 name: 'Regex',
                                //                 isVisible: true
                                //             },

                                //         ]
                                //     }
                                // },
                            ]
                        },
                        // Type: {
                        //     rules: [{
                        //         canOverwrite: true,
                        //         check: [{
                        //             condition: "AND",
                        //             rules: [{
                        //                 name: "Type", type: "=", value: 'I', rules: []
                        //             },
                        //             ]
                        //         }],
                        //         uncheck: true,
                        //         run: {
                        //             valid: [
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Minlen',
                        //                     isVisible: false
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Maxlen',
                        //                     isVisible: false
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Mask',
                        //                     isVisible: false
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Regex',
                        //                     isVisible: false
                        //                 },
                        //             ],
                        //             inValid: [
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Minlen',
                        //                     isVisible: true
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Maxlen',
                        //                     isVisible: true
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Mask',
                        //                     isVisible: true
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Regex',
                        //                     isVisible: true
                        //                 },

                        //             ]
                        //         }
                        //     },]// 1 intital load
                        // },
                        'subnavigation': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'initial',
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/ProjectMessages/Id?id={name}`,
                                                    alternateUrl: getEnvVariable('MasterAdmin') + `/api/ProjectMessages/Id?id={name}`,
                                                    condition: [
                                                        { value: 'Master', name: 'subnavigation.Path' }
                                                    ],
                                                    key: 'save',
                                                    "matchProps": [
                                                        {
                                                            name: "routeid1",
                                                            key: "routeid1",
                                                        },
                                                        {
                                                            name: "subnavigation.Id",
                                                            key: "name",
                                                        }
                                                    ],
                                                    type: 'get',
                                                }
                                            ]
                                        },
                                    ]
                                }
                            }]
                        },
                    },
                    'onChange': {
                        'edit': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'edit',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        // Type: {
                        //     rules: [{
                        //         canOverwrite: true,
                        //         check: [{
                        //             condition: "AND",
                        //             rules: [{
                        //                 name: "Type", type: "=", value: 'I', rules: []
                        //             },
                        //             ]
                        //         }],
                        //         uncheck: true,
                        //         run: {
                        //             valid: [
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Minlen',
                        //                     isVisible: false
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Maxlen',
                        //                     isVisible: false
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Mask',
                        //                     isVisible: false
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Regex',
                        //                     isVisible: false
                        //                 },
                        //             ],
                        //             inValid: [
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Minlen',
                        //                     isVisible: true
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Maxlen',
                        //                     isVisible: true
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Mask',
                        //                     isVisible: true
                        //                 },
                        //                 {
                        //                     type: 'prop',
                        //                     name: 'Regex',
                        //                     isVisible: true
                        //                 },

                        //             ]
                        //         }
                        //     },]// 1 intital load
                        // },
                        'subnavigation': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'initial',
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/ProjectMessages/Id?id={name}`,
                                                    alternateUrl: getEnvVariable('MasterAdmin') + `/api/ProjectMessages/Id?id={name}`,
                                                    condition: [
                                                        { value: 'Master', name: 'subnavigation.Path' }
                                                    ],
                                                    key: 'save',
                                                    "matchProps": [
                                                        {
                                                            name: "routeid1",
                                                            key: "routeid1",
                                                        },
                                                        {
                                                            name: "subnavigation.Id",
                                                            key: "name",
                                                        }
                                                    ],
                                                    type: 'get',
                                                }
                                            ]
                                        },
                                    ]
                                }
                            }]
                        },
                    },
                    afterSave: {
                        'save': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/ProjectMessages/Update`,
                                                        alternateUrl: getEnvVariable('MasterAdmin') + `/api/ProjectMessages/Update`,
                                                        condition: [
                                                            { value: 'Master', name: 'subnavigation.Path' }
                                                        ],
                                                        type: 'put',
                                                        "matchProps": [
                                                            {
                                                                name: "TableName",
                                                                key: "name",
                                                            }
                                                        ],

                                                    }
                                                ],
                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    }

                }
            }
        },

    }
}

export default ProjectMessagesTableEdit